import { render } from "./TripReportPrintPreview.vue?vue&type=template&id=87e859dc&scoped=true"
import script from "./TripReportPrintPreview.vue?vue&type=script&lang=js"
export * from "./TripReportPrintPreview.vue?vue&type=script&lang=js"

import "./TripReportPrintPreview.vue?vue&type=style&index=0&id=87e859dc&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87e859dc"]])

export default __exports__